// utils/userId.js
export function getUserId() {
  let userId = localStorage.getItem('modelguessr_userId');
  if (!userId) {
    userId = crypto.randomUUID();
    localStorage.setItem('modelguessr_userId', userId);
  }
  return userId;
}